"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StackBox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
var _tss = require("../styles/tss");
var _box = _interopRequireDefault(require("../system/box"));
var _breakpoints = require("../system/breakpoints");
var _compose = _interopRequireDefault(require("../system/compose"));
var _css = _interopRequireDefault(require("../system/css"));
var _style = require("../system/style");
var _omit = require("../utilities/omit");
const _excluded = ["children", "className", "component"],
  _excluded2 = ["children", "className", "classes", "childWrapperComponent", "childWrapperProps", "display", "direction", "alignItems", "justifyContent", "spacing"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const REVERSE_DIRECTIONS = ['row-reverse', 'column-reverse'];
const useStyles = (0, _createStyles.createStyles)(() => ({
  root: {}
}));
const spacingStyle = (0, _style.style)({
  prop: 'spacing',
  cssProperty: null,
  transform: (value, props) => {
    const {
      flexDirection,
      theme
    } = props;
    const allChildrenExceptLast = REVERSE_DIRECTIONS.includes(flexDirection) ? '& > :not(:first-child)' : '& > :not(:last-child)';

    // Spacing style depends on the "flexDirection" property which can be responsive,
    // so we need to handle the breakpoints for it.
    // The style function will handle it only for the prop being resolved (`spacing` in this case).
    return (0, _breakpoints.handleBreakpoints)(theme, flexDirection, finalDirection => {
      const isRow = String(finalDirection).substr(0, 3) === 'row';
      const marginToAdd = isRow ? 'marginRight' : 'marginBottom';
      const marginToRemove = isRow ? 'marginBottom' : 'marginRight';
      return {
        [allChildrenExceptLast]: {
          [marginToAdd]: theme.busbud.spacing(value),
          [marginToRemove]: 0
        }
      };
    });
  }
});
const styleFunction = (0, _css.default)((0, _compose.default)(_box.default, spacingStyle));
const StackBox = exports.StackBox = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    css,
    theme,
    cx
  } = (0, _tss.useEmptyStyles)();
  const {
      children,
      className,
      component: Component = 'div'
    } = props,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  const styles = styleFunction(_objectSpread({
    theme
  }, props));

  // Omit system props from props by filtering filterProps
  const {
    filterProps
  } = styleFunction;
  const cleanProps = (0, _omit.omit)(rest, filterProps);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: cx(css(styles), className),
    ref: ref
  }, cleanProps), children);
});
/**
 * **❗️ DEPRECATED**: Use Tailwind utility classes instead.
 *
 * The Stack component serves as a one-dimensional container for a row or a column of items. Ideally, the flow should be defined according to the breakpoint (i.e. switching to `column` on narrow displays) and `wrap` should not be defined. If the normal Flexbox behavior is needed, `Box` should be used instead.
 *
 * Implementation inspired by ChakraUI:
 * https://github.com/chakra-ui/chakra-ui/blob/dace172c851210d12e0d841a62f3532fd0974203/packages/layout/src/stack.tsx
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-layout-stack--page)
 *
 * @deprecated
 */
const Stack = /*#__PURE__*/_react.default.forwardRef(function Stack(props, ref) {
  const {
      children,
      className,
      classes: classesOverrides,
      childWrapperComponent: ChildWrapper = _react.default.Fragment,
      childWrapperProps = {},
      display = 'flex',
      direction = 'row',
      alignItems = 'stretch',
      justifyContent = 'flex-start',
      spacing = undefined
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded2);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  if (!children) return null;
  const childrenToRender = children.filter(child => !!child);
  if (childrenToRender.length === 0) return null;
  return /*#__PURE__*/_react.default.createElement(StackBox, (0, _extends2.default)({
    flexWrap: "nowrap",
    ref: ref,
    display: display,
    flexDirection: direction,
    className: cx(classes.root, className),
    alignItems: alignItems,
    justifyContent: justifyContent,
    spacing: spacing
  }, other), childrenToRender.map((child, index) => /*#__PURE__*/_react.default.createElement(ChildWrapper, (0, _extends2.default)({
    key: index
  }, childWrapperProps), child)));
});
var _default = exports.default = Stack;